import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'next-i18next'
import { getAnniversarySvgUrl } from './anniversaryAssets'

const Logo = styled.div`
  flex-shrink: 0;
  line-height: 0;
  pointer-events: none;

  img {
    width: 65px;
    height: 50px;
    display: block;
  }
`

const Wingie10YearsGreenLogo: React.FC = () => {
  const { i18n } = useTranslation()
  const src = getAnniversarySvgUrl('green', i18n?.language)

  return (
    <Logo data-testid="promoted-flight-wingie-10-years-logo" aria-hidden="true">
      <img src={src} alt="" width={65} height={50} decoding="async" />
    </Logo>
  )
}

export default Wingie10YearsGreenLogo
